import { defineStore } from 'pinia'

import type { AssessmentTemplatesStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useAssessmentTemplatesStore = defineStore('assessment-templates', {
  state: (): AssessmentTemplatesStore => ({
    loading: false,
    templatesPaginatedData: null,
    filterSearch: null,
    filterType: null,
    filterDisciplineCode: null,
    filterGrade: null,
    filterStatus: null,
    currentPage: 1,
    perPage: 25,
    isModalCreate: false,
    templateToDelete: null,
    templateToDuplicate: null,
    deleteBlockedAssessmentsCount: null,
  }),
  actions,
  getters,
})
